// extracted by mini-css-extract-plugin
module.exports = {"themes_wrapper":"ThemesCards_themes_wrapper__FSLpx","mainTitle":"ThemesCards_mainTitle__aj5h_","subtitle":"ThemesCards_subtitle__CYikI"};